module.exports = __webpack_public_path__ + "static/media/default_user.8e52b8c8.png";